import template from './tickertape.html';
import controller from './tickertape.controller';
import './tickertape.scss';

let tickertapeComponent = {
  bindings: {
    article: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default tickertapeComponent;



// WEBPACK FOOTER //
// ./client/app/components/content-types/tickertape/tickertape.component.js